import { Tooltip } from "@chakra-ui/react";
import React, { useState, useEffect } from "react";
import FirebaseProvider from "../api/firebaseProvider";
import { sortProjects } from "../helpers";
import LoadingBlock from "./LoadingBlock";
import ScratchProject from "./ScratchProject";

const ScratchathonProjectList = ({ scratchathonID, projectSort = false }) => {
  const [loaded, setLoaded] = useState(false);
  const [projects, setProjects] = useState([]);

  useEffect(async () => {
    const projects = await FirebaseProvider.getEventProjects(scratchathonID);
    setProjects(sortProjects(projects, projectSort));
    setLoaded(true);
  }, []);

  useEffect(async () => {
    setProjects(sortProjects(projects, projectSort));
  }, [projectSort]);

  if (!loaded) return <LoadingBlock />;

  return (
    <div className="space-y-2">
      <Tooltip
        label={`Number of total projects submitted (${projects.length})`}
        bg="gray.100"
        hasArrow
        color="gray.700"
        openDelay={300}
        closeDelay={300}
      >
        <p className="text-gray-400 uppercase text-sm font-bold inline-flex">
          {projects.length} Projects
        </p>
      </Tooltip>

      <div className="grid md:grid-cols-3 gap-6 items-stretch">
        {projects.map((project, i) => {
          return <ScratchProject key={i} {...project} />;
        })}
      </div>
    </div>
  );
};

export default ScratchathonProjectList;
